<template>
  <div>
    <CollectionView endpoint="admin/users" searchable v-model:reload="reload">
      <template v-slot:header>
        <h4 class="mb-0">{{ translate("users") }}</h4>
      </template>
      <template v-slot:content="{ items }">
        <div class="card">
          <div class="table-responsive">
            <div class="table">
              <div class="table-header">
                <div class="table-header-cell">{{ translate("name") }}</div>
                <div class="table-header-cell">ID</div>
              </div>
              <div class="table-body">
                <div class="table-row" v-for="item in items" :key="item.id">
                  <div class="table-column">
                    <UserView :user="item"/>
                  </div>
                  <div class="table-column">
                    {{ item.id }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollectionView>
  </div>
</template>

<script setup>
import {CollectionView} from "@/niftybit";
import UserView from "@/components/other/UserView.vue";
import {ref} from "vue";

defineProps({
  communityId: String
});

const reload = ref(false);

</script>